/**
 * home about actions(type & creator)
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
export const GET_CATEGORY = 'GET_CATEGORY';
export const RECEIVE_CATEGORY = 'RECEIVE_CATEGORY';
export const GET_BRAND_BY_CID = 'GET_BRAND';
export const RECEIVE_BRAND = 'RECEIVE_BRAND';
export const GET_PRODUCT = 'GET_PRODUCT';
export const RECEIVE_PRODUCT = 'RECEIVE_PRODUCT';
export const GET_HOME = 'GET_HOME';
export const GET_HOT = 'GET_HOT';
export const RECEIVE_HOT = 'RECEIVE_HOT';
export const GET_HOME_BY_CID = 'GET_HOME_BY_CID';
export const CHANGE_BID = 'CHANGE_BID';
export const CHANGE_CID = 'CHANGE_CID';
export const GET_PAGE_INFO = 'GET_PAGE_INFO';
export const RECEIVE_PAGE_INFO = 'RECEIVE_PAGE_INFO';

/**
 * get category creator
 * @param  {number} cid   category id
 */
export const getCategory = cid => ({
  type: GET_CATEGORY,
  cid
})

/**
 * receive category creator
 * @param  {object[]} category 
 * @return {object}
 */
export const receiveCategory = category => ({
  type: RECEIVE_CATEGORY,
  category
})

/**
 * receive brand creator
 * @param  {object} brand  brands data
 * @return {object}
 */
export const receiveBrand = brand => ({
  type: RECEIVE_BRAND,
  brand
})

/**
 * get product list by category id & brand id & page
 * @param  {number} cid     category id
 * @param  {number} bid     brand id
 * @param  {number} current page number
 * @return {object}
 */
export const getProduct = (cid, bid, current) => ({
  type: GET_PRODUCT,
  cid,
  bid,
  current
})

/**
 * receive product creator
 * @param  {object} product  product & page data
 * @return {object}
 */
export const receiveProduct = product => ({
  type: RECEIVE_PRODUCT,
  product
})

/**
 * get home creator(for init)
 * @return {object}
 */
export const getHome = () => ({
  type: GET_HOME
})

/**
 * get hot product creator
 * @return {object}
 */
export const getHot = () => ({
  type: GET_HOT
})

/**
 * receive hot product data creator
 * @param  {object[]} hot     hot product data
 * @return {object}
 */
export const receiveHot = hot => ({
  type: RECEIVE_HOT,
  hot
})

/**
 * get homepage product & brand data by category id
 * @param {number} cid  category id
 * @param {number} bid  brand id
 */
export const getHomeByCid = (cid, bid, current) => ({
  type: GET_HOME_BY_CID,
  cid,
  bid,
  current
})

/**
 * change brand id
 * @param  {number} bid  brand id
 * @return {object}
 */
export const changeBid = (bid) => ({
  type: CHANGE_BID,
  bid
})

/**
 * change category id
 * @param  {number} cid  category id
 * @return {object}
 */
export const changeCid = (cid) => ({
  type: CHANGE_CID,
  cid
})

/**
 * get pageinfo data(banner & qa)
 * @param  {number} isPreview
 * @return {object}
 */
export const getPageInfo = (isPreview) => ({
  type: GET_PAGE_INFO,
  isPreview
})

/**
 * receive pageinfo data(banner & qa)
 * @param  {object} pageInfo
 * @return {object}
 */
export const receivePageInfo = (pageInfo) => ({
  type: RECEIVE_PAGE_INFO,
  pageInfo
})



// WEBPACK FOOTER //
// ./src/actions/home.js